<template>
  <b-overlay
    :show="loading && !noOverlay"
    blur="1rem"
    opacity="0.6"
    rounded="lg"
    variant="transparent"
  >
    <b-card v-if="!custom" class="card-radius">
      <slot></slot>
    </b-card>

    <slot v-else></slot>

    <b-card v-if="!hideActions" class="card-radius">
      <div class="d-flex align-items-center justify-content-between">
        <b-btn
          id="ff-back-btn"
          :disabled="loading"
          class="d-flex align-items-center justify-content-center"
          variant="secondary"
          @click="customBack ? $emit('back') : onBackClick()"
        >
          <font-awesome-icon
            :class="`m${$dir.rtl ? 'l' : 'r'}-2`"
            :icon="historyAvailable ? backIcon : 'times'"
          />

          <span>
            {{ historyAvailable ? backText : $t('shared.Close') }}
          </span>
        </b-btn>

        <div class="d-flex align-items-center">
          <slot name="actions"></slot>
          <b-btn
            v-if="!hideSubmit"
            id="ff-submit-btn"
            :disabled="loading || submitDisabled"
            class="mr-4 d-flex align-items-center justify-content-center"
            variant="success"
            @click="$emit('submit')"
          >
            <font-awesome-icon
              :class="`m${$dir.rtl ? 'l' : 'r'}-2`"
              :icon="submitIcon"
            />

            <span>
              {{ submitText }}
            </span>
          </b-btn>
        </div>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
export default {
  name: 'BrbFormWrapper',
  props: {
    custom: Boolean,
    loading: Boolean,
    noOverlay: Boolean,
    hideActions: Boolean,
    submitDisabled: Boolean,
    submitText: {
      type: String,
      default: function () {
        return this.$t('shared.Save')
      }
    },
    submitIcon: {
      type: String,
      default: 'save'
    },
    backText: {
      type: String,
      default: function () {
        return this.$t('shared.Return')
      }
    },
    backIcon: {
      type: String,
      default: 'undo-alt'
    },
    customBack: Boolean,
    hideSubmit: Boolean
  },
  computed: {
    historyAvailable() {
      return window.history.length > 1
    }
  },
  methods: {
    onBackClick() {
      if (this.historyAvailable) {
        this.$router.back()
      } else {
        try {
          window.close()
        } catch (e) {
          console.error(e)
        }
      }
    }
  }
}
</script>
